<template xmlns="http://www.w3.org/1999/html">
  <div>
    <!--    <minhead :headtitle="headtitle"></minhead>-->
	<el-card class="box-card">
		<div slot="header" class="clearfix">
		  <span>发票汇总统计表</span>
		</div>
		   <div class="Centerupdown">
			  <!-- <el-button  @click="typeBtn('026')">电子普票</el-button> -->
			  <div class="backstyle" style="width: 80px;margin-left: 20px;"  @click="typeBtn('026')" >
			  	<samp>
			  	电子普票
			  	</samp>
			  </div>
			  <div class="backstyle" style="width: 80px;margin-left: 20px;"  @click="typeBtn('028')" >
			  	<samp>
			  	电子专票
			  	</samp>
			  </div>
			  <div class="backstyle" style="width: 80px;margin-left: 20px;"  @click="typeBtn('007')" >
			  	<samp>
			  	纸质普票
			  	</samp>
			  </div>
			  <div class="backstyle" style="width: 80px;margin-left: 20px;"  @click="typeBtn('004')" >
			  	<samp>
			  	纸质专票
			  	</samp>
			  </div>
			  </div>
			 <!-- <el-button  @click="typeBtn('028')">电子专票</el-button>
			  <el-button  @click="typeBtn('007')">纸质普票</el-button>
			  <el-button  @click="typeBtn('004')">纸质专票</el-button> -->
              <div  class="Centerupdown" style="float: right;margin-top: 30px;margin-bottom: 16px;">
                  <!-- <el-button type="primary" plain @click='printTable'>打印销项汇总表</el-button> -->
				  <div class="addstyle" style="width: 120px;margin-left: 20px;" @click='printTable'>
				  	<samp>
				  	打印销项汇总表
				  	</samp>
				  </div>
                  <el-dropdown class="avatar-container" trigger="click" style='margin-left: 10px;'>
                      <!-- <div class="avatar-wrapper">
                          <el-button type="primary" plain>
                              导出数据
                              <i class="el-icon-caret-bottom" />
                          </el-button>
                      </div> -->
					  <div class="addstyle" style="width: 100px;margin-left: 20px;">
					  	<samp>
					  	导出数据
					  	<i class="el-icon-caret-bottom" />
					  	</samp>
					  </div>
                      <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="exportData">汇总统计表</el-dropdown-item>
                          <el-dropdown-item @click.native="exportDataDetail">发票明细表</el-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
              </div>

	</el-card>
	<el-card class="box-card">
	  <el-form :model="KCsummaryConditionForm" ref="KCsummaryConditionForm" label-width="80px" style="padding: 5px;">
	    <div class="form-item">
		  <span>库存信息</span>
	      <el-select style="width: 120px;margin-left: 30px;" v-model="KCsummaryConditionForm.year">
	        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
	        </el-option>
	      </el-select>
	      <el-select style="width: 120px;margin-left: 30px;" v-model="KCsummaryConditionForm.monthSeason">
	        <el-option v-for="item in KCmonthSeasons" :key="item.value" :label="item.label" :value="item.value"></el-option>
	      </el-select>
        <el-select v-model="kaipzddm"  style="width: 150px;margin-left: 30px;" placeholder="税盘编号">
          <el-option v-for="item in kpjList" :key="item.kaipjbh"
                     :label="item.kaipjbh" :value="item.kaipjbh"></el-option>
        </el-select>
		  <div class="Centerupdown" style="margin-left: 210px;">
		    <!-- <el-button type="primary" style="width: 100px" plain @click="KCquerySummary">统计</el-button> -->
			<div class="addstyle" style="width: 80px;margin-left: 20px;" @click='KCquerySummary'>
				<samp>
				统计
				</samp>
			</div>
			<div class="addstyle" style="width: 80px;margin-left: 20px;" @click='resetKCForm'>
				<samp>
				重置
				</samp>
			</div>
		    <!-- <el-button type="primary" style="width: 100px" plain @click="resetKCForm">重置</el-button> -->
		  </div>
	    </div>
	  </el-form>
	  <div class="tableall">
	  <div class=" boderall" style="margin-top: 10px">
	    <div  style="width: 8%;" class="divlabel">
	      初期库存
	    </div>
	    <div style="width:12%" >
	     {{ startInventoryCount }}
	    </div>
	    <div style="width: 8%;"  class="divlabel">
	      购进发票
	    </div>
	    <div style="width:12%">
	      {{ buyInvoices }}
	    </div>
	    <div style="width: 8%;"  class="divlabel">
	      分配发票
	    </div>
	    <div style="width:12%">
            {{ allocationInvoices }}
	    </div>
	  </div>
	  <div  class=" boderall boderall2" >
	    <div  style="width: 8%;" class="divlabel">
	      期末库存
	    </div>
	    <div style="width:12%">
	      {{ lastInventoryCount }}
	    </div>
	    <div style="width: 8%;"  class="divlabel">
	      退回发票
	    </div>
	    <div style="width:12%">
	      {{ returnInvoices }}
	    </div>
	    <div style="width: 8%;"  class="divlabel">
	      收回发票
	    </div>
	    <div style="width:12%">
	      0
	    </div>
	  </div>
	  </div>
	</el-card>
   <el-card class="box-card">
	   <el-form :model="HZsummaryConditionForm" ref="HZsummaryConditionForm" label-width="80px" style="padding: 5px;">
	     <div class="form-item">
			 <span>开票汇总</span>
	       <el-select style="width: 120px;margin-left: 30px;" v-model="HZsummaryConditionForm.summaryType"
	                  @change="selectSummaryType">
	         <el-option label="按月度统计" value="1"></el-option>
<!--	         <el-option label="按季度统计" value="2"></el-option>
	         <el-option label="按年度统计" value="3"></el-option>-->
	       </el-select>
	       <el-select style="width: 120px;margin-left: 30px;" v-model="HZsummaryConditionForm.year">
	         <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
	         </el-option>
	       </el-select>
	       <el-select style="width: 120px;margin-left: 30px;" v-model="HZsummaryConditionForm.monthSeason"
	                  v-if="HZsummaryConditionForm.summaryType != '3'">
	         <el-option v-for="item in monthSeasons" :key="item.value" :label="item.label" :value="item.value"></el-option>
	       </el-select>
         <el-select v-model="kaipzddm"  style="width: 150px;margin-left: 30px;" placeholder="税盘编号">
           <el-option v-for="item in kpjList" :key="item.kaipjbh"
                      :label="item.kaipjbh" :value="item.kaipjbh"></el-option>
         </el-select>
	   	<div class="Centerupdown"style="margin-left: 60px;">
			<div class="addstyle" style="width: 80px;margin-left: 20px;" @click='HZquerySummary'>
				<samp>
				统计
				</samp>
			</div>
	   	  <!-- <el-button type="primary" style="width: 100px" plain @click="HZquerySummary">统计</el-button> -->
		  <div class="addstyle" style="width: 80px;margin-left: 20px;" @click='resetHZForm'>
		  	<samp>
		  	重置
		  	</samp>
		  </div>
	   	  <!-- <el-button type="primary" style="width: 100px" plain @click="resetHZForm">重置</el-button> -->
	   	</div>
	     </div>
	   </el-form>	
      <div class="tableall">
      <div class=" boderall" style="margin-top: 10px">
        <div  style="width: 8%;" class="divlabel">
          发票种类
        </div>
        <div style="width:12%;border-left: 1px solid #E7E7E7;" >
          正数发票
        </div>
        <div style="width: 12%;;border-left: 1px solid #E7E7E7;;border-left: 1px solid #E7E7E7;">
			正数废票
        </div>
        <div style="width:12%;border-left: 1px solid #E7E7E7;">
			负数发票
        </div>
        <div style="width: 12%;border-left: 1px solid #E7E7E7;" >
          负数废票
        </div>
		<div style="width: 12%;border-left: 1px solid #E7E7E7;" >
		  合计发票
		</div>
      </div>
      <div  class=" boderall boderall2" >
        <div  style="width: 8%;" class="divlabel">
          发票份数
        </div>
        <div style="width:12%;border-left: 1px solid #E7E7E7;">
          {{    positiveIssuedCount}}
        </div>
		<div style="width:12%;border-left: 1px solid #E7E7E7;">
		  {{    positiveCancelCount }}
		</div>
		<div style="width:12%;border-left: 1px solid #E7E7E7;">
			{{    negativeIssuedCount }}
		</div>
		<div style="width:12%;border-left: 1px solid #E7E7E7;">
		{{    negativeCancelCount }}
		</div>
		<div style="width:12%;border-left: 1px solid #E7E7E7;">
		{{    totalCount }}
		</div>
      </div>
      </div>
	  <div class="areacontent">
	          <div class="tableh" style="margin:10px 20px">
	            <template>
	              <el-table :data="tableData" border style="width: 100%" ref="multipleTable" :height="tableHeight">
	                <el-table-column prop="type" label="项目名称" width="150">
	                  <template slot-scope="scope">
	                    <p v-if="scope.row.type == '01'">销项正废金额</p>
	                    <p v-if="scope.row.type == '02'">销项正数金额</p>
	                    <p v-if="scope.row.type == '03'">销项负废金额</p>
	                    <p v-if="scope.row.type == '04'">销项负数金额</p>
	                    <p v-if="scope.row.type == '05'">实际销售金额</p>
	                    <p v-if="scope.row.type == '06'">销项正废税额</p>
	                    <p v-if="scope.row.type == '07'">销项正数税额</p>
	                    <p v-if="scope.row.type == '08'">销项负废税额</p>
	                    <p v-if="scope.row.type == '09'">销项负数税额</p>
	                    <p v-if="scope.row.type == '10'">实际销售税额</p>
	                  </template>
	                </el-table-column>
	                <el-table-column prop="totalAmount" label="合计" width="100">
	                  <template slot-scope="scope">
	                    <span>{{ toThousands(Amountformat(scope.row.totalAmount)) }}</span>
	                  </template>
	                </el-table-column>
<!--	                <el-table-column prop="threePercent" label="3%" width="100" v-if="this.columnHiddenShow.threePercentShow">-->
<!--	                  <template slot-scope="scope">-->
<!--	                    <span>{{ toThousands(Amountformat(scope.row.threePercent)) }}</span>-->
<!--	                  </template>-->
<!--	                </el-table-column>-->
<!--	                <el-table-column prop="fourPercent" label="4%" width="100" v-if="this.columnHiddenShow.fourPercentShow">-->
<!--	                  <template slot-scope="scope">-->
<!--	                    <span>{{ toThousands(Amountformat(scope.row.fourPercent)) }}</span>-->
<!--	                  </template>-->
<!--	                </el-table-column>-->
                    <el-table-column prop="thirteenPercent" label="13%" width="100"
                                     v-if="this.columnHiddenShow.thirteenPercentShow">
                      <template slot-scope="scope">
                        <span>{{ toThousands(Amountformat(scope.row.thirteenPercent)) }}</span>
                      </template>
                    </el-table-column>

                      <el-table-column prop="thirteenPercent" label="10%" width="100"
                                       v-if="this.columnHiddenShow.tenPercentShow">
                          <template slot-scope="scope">
                              <span>{{ toThousands(Amountformat(scope.row.tenPercent)) }}</span>
                          </template>
                      </el-table-column>

                      <el-table-column prop="sixPercent" label="9%" width="100" v-if="this.columnHiddenShow.ninePercentShow">
                          <template slot-scope="scope">
                              <span>{{ toThousands(Amountformat(scope.row.ninePercent)) }}</span>
                          </template>
                      </el-table-column>

                      <el-table-column prop="sixPercent" label="6%" width="100" v-if="this.columnHiddenShow.sixPercentShow">
                          <template slot-scope="scope">
                              <span>{{ toThousands(Amountformat(scope.row.sixPercent)) }}</span>
                          </template>
                      </el-table-column>

                  <el-table-column prop="sixPercent" label="0%" width="100" v-if="this.columnHiddenShow.zeroPercentShow">
                    <template slot-scope="scope">
                      <span>{{ toThousands(Amountformat(scope.row.zeroPercent)) }}</span>
                    </template>
                  </el-table-column>


<!--	                <el-table-column prop="elevenPercent" label="11%" width="100"-->
<!--	                                 v-if="this.columnHiddenShow.elevenPercentShow">-->
<!--	                  <template slot-scope="scope">-->
<!--	                    <span>{{ toThousands(Amountformat(scope.row.elevenPercent)) }}</span>-->
<!--	                  </template>-->
<!--	                </el-table-column>-->

<!--	                <el-table-column prop="seventeenPercent" label="17%" width="100"-->
<!--	                                 v-if="this.columnHiddenShow.seventeenPercentShow">-->
<!--	                  <template slot-scope="scope">-->
<!--	                    <span>{{ toThousands(Amountformat(scope.row.seventeenPercent)) }}</span>-->
<!--	                  </template>-->
<!--	                </el-table-column>-->
	                <el-table-column prop="otherPercent" label="其他" width="100" v-if="this.columnHiddenShow.otherPercentShow">
	                  <template slot-scope="scope">
	                    <span>{{ toThousands(Amountformat(scope.row.otherPercent)) }}</span>
	                  </template>
	                </el-table-column>
	              </el-table>
	            </template>
	          </div>
	  
	        </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  components: {},
  data() {
    return {
      summaryConditionForm: {
        faplxdm: '026',
        summaryType: '',
        year: '',
        monthSeason: '',
        kaipzddm:''
      },
	  //库存查询
	  KCsummaryConditionForm: {
	    faplxdm: '026',
		summaryType: '1',
	    year: '',
	    monthSeason: '',
      kaipzddm:''
	  },
	  HZsummaryConditionForm: {
	    faplxdm: '026',
	    summaryType: '',
	    year: '',
	    monthSeason: '',
      kaipzddm:''
	  },
      monthSeasons: [{}],
      years: this.getYears(),
      formLabelWidth: '150px',
      tableHeight: '',
      tableData: [],
      columnHiddenShow: {
        'zeroPercentShow': true,
        'onePercentShow': true,
        'onePointFivePercentShow': true,
        'twoPercentShow': true,
        'threePercentShow': true,
        'fourPercentShow': true,
        'fivePercentShow': true,
        'sixPercentShow': true,
        'ninePercentShow': true,
        'tenPercentShow': true,
        'elevenPercentShow': true,
        'thirteenPercentShow': true,
        'sixteenPercentShow': true,
        'seventeenPercentShow': true,
        'otherPercentShow': true
      },
      positiveIssuedCount: 0,
      positiveCancelCount: 0,
      negativeIssuedCount: 0,
      negativeCancelCount: 0,
      startInventoryCount: 0,
      lastInventoryCount: 0,
      allocationInvoices: 0,
      returnInvoices: 0,
      buyInvoices: 0,
      totalCount: 0,
      buttomroute: {},
      kpjList:[],
      kaipzddm:'',
      faplxdm:"",
    };
  },
  created() {
    this.HZsummaryConditionForm.year = this.years[0].value;
	this.KCsummaryConditionForm.year = this.years[0].value;
    this.HZsummaryConditionForm.summaryType = '1';
	this.selectSummaryType();
    this.HZsummaryConditionForm.faplxdm = '026';
	this.KCmonthSeasons = [
	  {
	    label: '1月',
	    value: '1'
	  },
	  {
	    label: '2月',
	    value: '2'
	  },
	  {
	    label: '3月',
	    value: '3'
	  },
	  {
	    label: '4月',
	    value: '4'
	  },
	  {
	    label: '5月',
	    value: '5'
	  },
	  {
	    label: '6月',
	    value: '6'
	  },
	  {
	    label: '7月',
	    value: '7'
	  },
	  {
	    label: '8月',
	    value: '8'
	  },
	  {
	    label: '9月',
	    value: '9'
	  },
	  {
	    label: '10月',
	    value: '10'
	  },
	  {
	    label: '11月',
	    value: '11'
	  },
	  {
	    label: '12月',
	    value: '12'
	  }
	];
	let date = new Date();
	this.KCsummaryConditionForm.monthSeason = Math.ceil(date.getMonth() + 1) + '';
    this.loadKpjList();
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.diagheightfushutiankai();
      this.$refs.multipleTable.doLayout();
      window.onresize = () => {
        this.tableHeight = this.diagheightfushutiankai();
        this.$refs.multipleTable.doLayout();
      };
    });
  },
  methods: {
    selectSummaryType() {
      // 按月度统计
      let date = new Date();
      if (this.HZsummaryConditionForm.summaryType == '1') {
        this.monthSeasons = [
          {
            label: '1月',
            value: '1'
          },
          {
            label: '2月',
            value: '2'
          },
          {
            label: '3月',
            value: '3'
          },
          {
            label: '4月',
            value: '4'
          },
          {
            label: '5月',
            value: '5'
          },
          {
            label: '6月',
            value: '6'
          },
          {
            label: '7月',
            value: '7'
          },
          {
            label: '8月',
            value: '8'
          },
          {
            label: '9月',
            value: '9'
          },
          {
            label: '10月',
            value: '10'
          },
          {
            label: '11月',
            value: '11'
          },
          {
            label: '12月',
            value: '12'
          }
        ];
        this.HZsummaryConditionForm.monthSeason = date.getMonth() + 1 + '';
      } else if (this.HZsummaryConditionForm.summaryType == '2') {
        this.monthSeasons = [
          {
            label: '第一季度',
            value: '1'
          },
          {
            label: '第二季度',
            value: '2'
          },
          {
            label: '第三季度',
            value: '3'
          },
          {
            label: '第四季度',
            value: '4'
          }
        ];
        this.HZsummaryConditionForm.monthSeason = Math.ceil((date.getMonth() + 1) / 3) + '';
      }
    },
    typeBtn(faplxdm){
      //this.summaryConditionForm.faplxdm=faplxdm;
	  this.KCsummaryConditionForm.faplxdm=faplxdm;
	  this.HZsummaryConditionForm.faplxdm=faplxdm;
      this.faplxdm = faplxdm,
      this.querySummary();
    },
    getYears() {
      let date = new Date();
      let currentYear = date.getFullYear();
      let yearOptions = [];
      for (let year = currentYear; year > currentYear - 10; year--) {
        yearOptions.push({
          label: year + '年',
          value: year + ''
        });
      }
      return yearOptions;
    },
	//库存查询
	KCquerySummary(){
    this.KCsummaryConditionForm.kaipzddm=this.kaipzddm;
		let params = JSON.parse(JSON.stringify(this.KCsummaryConditionForm));
		console.log(params);
		if(params.year == '' || params.year == null){
			 this.$message.info("请选择年份");
			return;
		}
		if(params.monthSeason == '' || params.monthSeason == null){
			this.$message.info("请选择月份");
			return;
		}
		this.KCsubmitQuerySummary(params);
	},
	//汇总查询
	HZquerySummary(){
    this.HZsummaryConditionForm.kaipzddm=this.kaipzddm;
      let params = JSON.parse(JSON.stringify(this.HZsummaryConditionForm));
      if (params.summaryType == '3') {
        this.$confirm('是否已进行税控同步', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        }).then(() => {
          this.HZsubmitQuerySummary(params);
        });
      } else {
        this.HZsubmitQuerySummary(params);
      }
	},
	//同时查询库存 和 汇总
	querySummary() {
		this.KCquerySummary();
		this.HZquerySummary();
	},
    // querySummary() {
    //   let params = JSON.parse(JSON.stringify(this.summaryConditionForm));
    //   if (params.summaryType == '3') {
    //     this.$confirm('是否已进行税控同步', '提示', {
    //       confirmButtonText: '是',
    //       cancelButtonText: '否',
    //       type: 'info'
    //     }).then(() => {
    //       this.submitQuerySummary();
    //     });
    //   } else {
    //     this.submitQuerySummary();
    //   }
    // },
    async submitQuerySummary(params) {
      //let params = JSON.parse(JSON.stringify(this.summaryConditionForm));
      await this.$https.fetchPost('real/summaryReportInfo', params).then(res => {
        res.data.obj.rows.forEach(item => {
          if (item.zeroPercent != 0) {
            this.columnHiddenShow.zeroPercentShow = true;
          }
          if (item.onePercent != 0) {
            this.columnHiddenShow.onePercentShow = true;
          }
          if (item.onePointFivePercent != 0 != 0) {
            this.columnHiddenShow.onePointFivePercentShow = true;
          }
          if (item.twoPercent != 0) {
            this.columnHiddenShow.twoPercentShow = true;
          }
          if (item.threePercent != 0) {
            this.columnHiddenShow.threePercentShow = true;
          }
          if (item.fourPercent != 0) {
            this.columnHiddenShow.fourPercentShow = true;
          }
          if (item.fivePercent != 0) {
            this.columnHiddenShow.fivePercentShow = true;
          }
          if (item.sixPercent != 0) {
            this.columnHiddenShow.sixPercentShow = true;
          }
          if (item.ninePercent != 0) {
            this.columnHiddenShow.ninePercentShow = true;
          }
          if (item.tenPercent != 0) {
            this.columnHiddenShow.tenPercentShow = true;
          }
          if (item.elevenPercent != 0) {
            this.columnHiddenShow.elevenPercentShow = true;
          }
          if (item.thirteenPercent != 0) {
            this.columnHiddenShow.thirteenPercentShow = true;
          }
          if (item.sixteenPercent != 0) {
            this.columnHiddenShow.sixteenPercentShow = true;
          }
          if (item.seventeenPercent != 0) {
            this.columnHiddenShow.seventeenPercentShow = true;
          }
          if (item.otherPercent != 0) {
            this.columnHiddenShow.otherPercentShow = true;
          }
        });
        this.tableData = res.data.obj.rows;
        this.positiveIssuedCount = res.data.obj.positiveCount;
        this.positiveCancelCount = res.data.obj.positiveCancelCount;
        this.negativeIssuedCount = res.data.obj.negativeCount;
        this.negativeCancelCount = res.data.obj.negativeCancelCount;
        this.startInventoryCount = res.data.obj.startInventory;
        this.lastInventoryCount = res.data.obj.lastInventory;
        this.allocationInvoices = res.data.obj.allocationInvoices;
        this.buyInvoices = res.data.obj.buyInvoices;
        this.totalCount = res.data.obj.totalCount;
        this.returnInvoices = res.data.obj.returnInvoices;
      });
    },   async KCsubmitQuerySummary(params) {
      await this.$https.fetchPost('real/kcSummaryReportInfo', params).then(res => {
        // this.positiveIssuedCount = res.data.obj.positiveCount;
        // this.positiveCancelCount = res.data.obj.positiveCancelCount;
        // this.negativeIssuedCount = res.data.obj.negativeCount;
        // this.negativeCancelCount = res.data.obj.negativeCancelCount;
        this.startInventoryCount = res.data.obj.startInventory;
        this.lastInventoryCount = res.data.obj.lastInventory;
        //this.totalCount = res.data.obj.totalCount;
          this.buyInvoices = res.data.obj.buyInvoices;
          this.allocationInvoices = res.data.obj.allocationInvoices;
          this.returnInvoices = res.data.obj.returnInvoices;
          this.totalCount = res.data.obj.totalCount;
      });
    },   async HZsubmitQuerySummary(params) {
      //let params = JSON.parse(JSON.stringify(this.summaryConditionForm));
      await this.$https.fetchPost('real/hzSummaryReportInfo', params).then(res => {
        res.data.obj.rows.forEach(item => {
          if (item.zeroPercent != 0) {
            this.columnHiddenShow.zeroPercentShow = true;
          }
          if (item.onePercent != 0) {
            this.columnHiddenShow.onePercentShow = true;
          }
          if (item.onePointFivePercent != 0 != 0) {
            this.columnHiddenShow.onePointFivePercentShow = true;
          }
          if (item.twoPercent != 0) {
            this.columnHiddenShow.twoPercentShow = true;
          }
          if (item.threePercent != 0) {
            this.columnHiddenShow.threePercentShow = true;
          }
          if (item.fourPercent != 0) {
            this.columnHiddenShow.fourPercentShow = true;
          }
          if (item.fivePercent != 0) {
            this.columnHiddenShow.fivePercentShow = true;
          }
          if (item.sixPercent != 0) {
            this.columnHiddenShow.sixPercentShow = true;
          }
          if (item.ninePercent != 0) {
            this.columnHiddenShow.ninePercentShow = true;
          }
          if (item.tenPercent != 0) {
            this.columnHiddenShow.tenPercentShow = true;
          }
          if (item.elevenPercent != 0) {
            this.columnHiddenShow.elevenPercentShow = true;
          }
          if (item.thirteenPercent != 0) {
            this.columnHiddenShow.thirteenPercentShow = true;
          }
          if (item.sixteenPercent != 0) {
            this.columnHiddenShow.sixteenPercentShow = true;
          }
          if (item.seventeenPercent != 0) {
            this.columnHiddenShow.seventeenPercentShow = true;
          }
          if (item.otherPercent != 0) {
            this.columnHiddenShow.otherPercentShow = true;
          }
        });
        this.tableData = res.data.obj.rows;
        this.positiveIssuedCount = res.data.obj.positiveCount;
        this.positiveCancelCount = res.data.obj.positiveCancelCount;
        this.negativeIssuedCount = res.data.obj.negativeCount;
        this.negativeCancelCount = res.data.obj.negativeCancelCount;
        // this.startInventoryCount = res.data.obj.startInventory;
        // this.lastInventoryCount = res.data.obj.lastInventory;
        this.totalCount = res.data.obj.totalCount;
      });
    },
	//库存查询重置
    resetKCForm() {
      this.KCsummaryConditionForm.faplxdm = '026';
      this.KCsummaryConditionForm.summaryType = '1';
      this.selectSummaryType();
      this.KCsummaryConditionForm.year = new Date().getFullYear() + '';
      this.KCsummaryConditionForm.monthSeason = new Date().getMonth() + 1 + '';
      this.KCsummaryConditionForm.kaipzddm = "";
    },
	//发票统计重置
	resetHZForm() {
	  this.HZsummaryConditionForm.faplxdm = '026';
	  this.HZsummaryConditionForm.summaryType = '1';
	  this.selectSummaryType();
	  this.HZsummaryConditionForm.year = new Date().getFullYear() + '';
	  this.HZsummaryConditionForm.monthSeason = new Date().getMonth() + 1 + '';
    this.HZsummaryConditionForm.kaipzddm = "";
	},
	resetForm() {
	  this.summaryConditionForm.faplxdm = '004';
	  this.summaryConditionForm.summaryType = '1';
	  this.selectSummaryType();
	  this.summaryConditionForm.year = new Date().getFullYear() + '';
	  this.summaryConditionForm.monthSeason = new Date().getMonth() + 1 + '';
    this.summaryConditionForm.kaipzddm = "";
	},
    exportDataDetail() {
      let url = this.$https.baseURL + 'real/exportSummaryReportDetail'; //请求下载文件的地址
      let token = localStorage.getItem('token');
      //let param = JSON.parse(JSON.stringify(this.summaryConditionForm));
	  let param = JSON.parse(JSON.stringify(this.HZsummaryConditionForm));
      if (token != '' && token != null) {
        axios.defaults.headers.common['token'] = token;
      }
      const fileName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
      axios.post(url, param, {responseType: 'blob'})
          .then(res => {
            if (!res) return;
            let blob = new Blob([res.data], {
              type: 'blob'
            });
            let url = window.URL.createObjectURL(blob);
            let aLink = document.createElement('a');
            aLink.style.display = 'none';
            aLink.href = url;
            aLink.setAttribute('download', fileName + '汇总明细报表.xlsx'); // 下载的文件
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
            window.URL.revokeObjectURL(url);
          })
          .catch(error => {
            this.$message.error(error);
          });

    },
    exportData() {
      let url = this.$https.baseURL + 'real/exportSummaryReport'; //请求下载文件的地址
      let token = localStorage.getItem('token');
      //let param = JSON.parse(JSON.stringify(this.summaryConditionForm));
      this.HZsummaryConditionForm.kaipzddm=this.kaipzddm;
	  let param = JSON.parse(JSON.stringify(this.HZsummaryConditionForm));
      if (token != '' && token != null) {
        axios.defaults.headers.common['token'] = token;
      }
      const fileName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
      axios.post(url, param, {responseType: 'blob'})
          .then(res => {
            if (!res) return;
            let blob = new Blob([res.data], {
              type: 'blob'
            });
            let url = window.URL.createObjectURL(blob);
            let aLink = document.createElement('a');
            aLink.style.display = 'none';
            aLink.href = url;
            aLink.setAttribute('download', fileName + '汇总报表.xlsx'); // 下载的文件
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
            window.URL.revokeObjectURL(url);
          })
          .catch(error => {
            this.$message.error(error);
          });

    },
    loadKpjList() {
      this.$https.fetchPost('doc/getKaipjList').then(res => {
        if (res.data.success){
          this.kpjList = JSON.parse(res.data.obj);
          this.kaipzddm = this.kpjList[0].kaipjbh;
        }
      });
    },

      printTable(){
          let title = "";
          if (this.faplxdm == '026') {
              title = "增值税电子普票汇总表"
          } else if (this.faplxdm == '028') {
              title = "增值税电子专票汇总表"
          } else if (this.faplxdm == '007') {
              title = "增值税纸质普票汇总表"
          } else if (this.faplxdm == '004') {
              title = "增值税纸质专票汇总表"
          }
          let userobj=JSON.parse(localStorage.getItem("useropj"));
          let currCompany = userobj.currCompany;
          let data = JSON.parse(JSON.stringify(this.tableData));
          data.sort(this.up);
          let tableData = [[],[],[],[],[],[]];
          data.forEach(row => {
              tableData[0].push(this.toThousands(this.Amountformat(row.totalAmount)));
              tableData[1].push(this.toThousands(this.Amountformat(row.thirteenPercent)));
              tableData[2].push(this.toThousands(this.Amountformat(row.tenPercent)));
              tableData[3].push(this.toThousands(this.Amountformat(row.ninePercent)));
              tableData[4].push(this.toThousands(this.Amountformat(row.sixPercent)));
              tableData[5].push(this.toThousands(this.Amountformat(row.zeroPercent)));
          })

          let table = [{"合计":tableData[0]},{"13%":tableData[1]},{"10%":tableData[2]},{"9%":tableData[3]},{"6%":tableData[4]},{"0%":tableData[5]}];

          var date = new Date();
          var year= date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          let newDate = [year, '年', month , '月', day, "日"].join('')

          let rangeDate = this.HZsummaryConditionForm.year + "年" + this.HZsummaryConditionForm.monthSeason + "月 ~ " +  this.HZsummaryConditionForm.monthSeason + "月";
        let sendData = {cmd: "sendcmd", moduledll: "InvoiceSvrDll.dll",
            "senddata": {
                    "cmd": "printXXHZB",
                    "path": "",
                    "data":[{
                        "title": title,
                        "zbrq": newDate,
                        "ssqj": rangeDate,
                        "nsrdjh": currCompany.taxNumber,
                        "qymc": currCompany.name,
                        "dzdh": currCompany.addressPhone,
                        "zsfpfs": this.positiveIssuedCount,
                        "zsfipfs": this.positiveCancelCount,
                        "fsfpfs": this.negativeIssuedCount,
                        "fsfipfs": this.negativeCancelCount,
                        "gjfpfs": this.buyInvoices,
                        "thfpfs": this.returnInvoices ,
                        "qmkcfs": this.lastInventoryCount,
                        "table":table,
                        }
                    ],
            }
        };
          let wsurl = 'ws://127.0.0.1:50926/SysSvr';
          let ws = new WebSocket(wsurl);
          ws.onopen = function () {
              ws.send(JSON.stringify(sendData));
          };
          ws.onmessage = function (evt) {
              console.info('ws.onmessage');
              let msg = JSON.parse(evt.data);
              console.log('ws message' + msg);
          }
          // ws.close();
      },

      up(x,y){
          return x.type -y.type;
      }
  }
};
</script>

<style scoped lang="less">
.allnum:extend(.Centerupdown) {
  margin-left: 80px;

  span {
    margin-right: 20px;
    font-size: 18px;
    letter-spacing: 1px;
  }
}

.KCbuttonAll:extend(.end-flex) {
	display: inline-block;
	margin-left: 250px;
}
.HZbuttonAll:extend(.end-flex) {
	display: inline-block;
	margin-left: 100px;
}
.boderall{

  div:extend(.Centerhorizontally){
    border-top: 1px solid #E7E7E7;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    padding: 15px 25px 15px 25px;

  }
}
.boderall>div:nth-last-child(1){
  border-right: 1px solid #E7E7E7;
}
.boderall>div:nth-of-type(1){
  border-left: 1px solid #E7E7E7
}
.boderall2>div:nth-child(2n){

}
.boderall2>div{
  border-top: 1px solid #E7E7E7;
  border-bottom: 1px solid #E7E7E7;

}
.divlabel{
  background-color: #F4F6F8;
}
.tableall>div{
  display: flex;
}

</style>